
import { cx } from '@client/shared/lib/cx.ts';
import type { CalendarMode } from './use-booking-intake.ts';
import styles from './ListingDetails.module.css';

export function ModeToggle({
  mode,
  onSelect,
  disabled,
}: {
  mode: CalendarMode;
  onSelect: (next: CalendarMode) => void;
  disabled?: boolean;
}) {
  return (
    <div className={styles.modeToggle} role="radiogroup" aria-label="Calendar mode">
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'book'}
        disabled={disabled}
        className={cx(styles.modeOption, mode === 'book' && styles.modeOptionActive)}
        onClick={() => onSelect('book')}
      >
        Book
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'block'}
        disabled={disabled}
        className={cx(styles.modeOption, mode === 'block' && styles.modeOptionActive)}
        onClick={() => onSelect('block')}
      >
        Block time
      </button>
    </div>
  );
}
